module.exports = __webpack_public_path__ + "img/w3I.36473a3c.svg";